import Hero from "@/components/Hero";
import ReferenceSlider from "@/components/ReferenceSlider";
import Stats from "@/components/Stats";
import MobileApps from "@/components/MobileApps";
import Services from "@/components/Services";
import SocialMedia from "@/components/SocialMedia";
import About from "@/components/About";
import Marquee from "@/components/Marquee";
import WhyUs from "@/components/WhyUs";
import Software from "@/components/Software";
import References from "@/components/References";
import Blog from "@/components/Blog";
import CTA from "@/components/CTA";
import Contact from "@/components/Contact";
import { Reveal, Cascade } from "@/components/Reveal";
import { COMPANY } from "@/lib/data";

export default function Home() {
  return (
    <main>
      <Hero />
      <ReferenceSlider />
      <MobileApps />
      <Stats />
      <div className="flex flex-col gap-[100px] py-[100px] md:gap-[140px] md:py-[140px]">
        {/* ── Hizmetlerimiz master heading ── */}
        <Reveal className="container-shell text-center">
          <p className="overline">Hizmetlerimiz</p>
          <h2 className="heading-lg mt-4">
            <Cascade text="Tek çatı altında {tüm dijital ihtiyaçlarınız}." />
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-ink/60">
            Sosyal medya yönetiminden AKINSOFT yazılım çözümlerine, ekstra yazılım
            hizmetlerinden teknik desteğe kadar işletmenizin yanınızdayız.
          </p>
        </Reveal>

        {/* ── Bölüm 1: Sosyal Medya ve Marketing ── */}
        <SocialMedia />

        {/* ── Bölüm 2: AKINSOFT Yazılım Çözümleri ── */}
        <Services />

        {/* ── Bölüm 3: Ekstra Yazılım Çözümleri ── */}
        <Software />

        {/* ── Diğer bölümler ── */}
        <About />
        <Marquee />
        <WhyUs />
        <References />
        <Blog />
        <CTA />
        <Contact />
      </div>

      {/* SEO-rich content section */}
      <section className="container-shell py-16" aria-label="AKINSOFT Şanlıurfa hakkında">
        <Reveal>
          <div className="mx-auto max-w-4xl space-y-6 text-center text-sm leading-relaxed text-ink/50">
            <h2 className="text-lg font-semibold text-ink/70">
              AKINSOFT Şanlıurfa Bölge Bayi — Dijital Dönüşüm Çözümleri
            </h2>
            <p>
              <strong className="text-ink/60">TEKNO ŞURA</strong>, <strong className="text-ink/60">AKINSOFT Şanlıurfa Bölge Bayisi</strong> olarak
              Şanlıurfa, Haliliye, Eyyübiye, Karaköprü, Viranşehir, Siverek, Suruç, Birecik, Ceylanpınar, Harran,
              Akçakale, Bozova ve Hilvan başta olmak üzere tüm Güneydoğu Anadolu bölgesine hizmet vermektedir.
            </p>
            <p>
              <strong className="text-ink/60">AKINSOFT Wolvox ERP</strong> yazılımı ile işletmenizin stok yönetimi, cari hesap takibi,
              fatura kesimi, e-Fatura ve e-Arşiv entegrasyonu, üretim planlama, satın alma, satış ve raporlama
              süreçlerini tek bir platformda birleştirin. Ayrıca <strong className="text-ink/60">POS sistemleri</strong>, restoran otomasyonu,
              kafe yönetim yazılımı, market otomasyonu ve perakende çözümleriyle sektörünüze özel yazılımlar sunuyoruz.
            </p>
            <p>
              <strong className="text-ink/60">AKINSOFT yetkili bayisi</strong> olarak profesyonel kurulum, kullanıcı eğitimi, teknik destek,
              yazılım güncelleme ve veri aktarımı hizmetleriyle işletmenizin dijital dönüşümünü sorunsuz gerçekleştiriyoruz.
              Ücretsiz demo için hemen <a href={`tel:${COMPANY.phoneRaw}`} className="font-semibold text-orange hover:underline">{COMPANY.phone}</a> numarasını
              arayın veya web sitemizden demo talep formunu doldurun.
            </p>
          </div>
        </Reveal>
      </section>
    </main>
  );
}
